import { AudioContextClock, BrowserClock, MediaTrackPlayer } from '@ezchops/clock';
import { useEffect, useState } from 'react';
import { useAudioContext } from '../../contexts';
export function useTrackClock(track, practice, autoStart = false) {
    const audioContext = useAudioContext();
    const [clock, setClock] = useState(new BrowserClock);
    useEffect(() => {
        const trackUrl = track != null
            ? track.tracks.find((t) => t.tempo == practice.tempo)?.url
            : null;
        const newClock = trackUrl != null
            ? new MediaTrackPlayer(trackUrl, audioContext)
            : new AudioContextClock(audioContext);
        setClock(newClock);
        if (autoStart) {
            newClock.resume();
        }
        return () => {
            newClock.reset();
            newClock.close();
        };
    }, [practice, audioContext, track, autoStart]);
    return clock;
}
//# sourceMappingURL=useTrackClock.js.map